module.exports = __webpack_public_path__ + "static/media/GeojiLight.ecae17ae.svg";